<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
    Author: Johnny Palmer
  Author URL: http://sweetas.xyz
========================================================================================== -->


<template>
    <div id="knowledge-base-page">
      <!-- JUMBOTRON -->
      <div class="knowledge-base-jumbotron mt-5 mr-5 ml-5">
        <div class="knowledge-base-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
          <div class="vx-row">
            <div class="vx-col w-2/3">
              <h1 class="mb-1 text-white">Infopoint Editor</h1>
              <p class="text-white">Please Enter Infopoint Terminal or Address ( EG: IP001 )</p>            
            </div>
            <div class="vx-col w-1/6 text-right">
                <vs-button class="mt-5" to="/search">Home</vs-button>

            </div>
             <div class="vx-col w-1/6 text-right">
                <vs-button class="mt-5"  @click="importMintsoftProducts">Product Import</vs-button>
            </div> 
          </div>
          <vs-input icon-no-border placeholder="Infopoint address" v-model="searchQuery" icon-pack="feather" icon="icon-search" size="large" class="w-full mt-6" />
        </div>          
      </div>

      <!-- KNOWLEDGE BASE CARDS  -->
      <div class="vx-row ml-5 mr-5">
              <div class="vx-col w-full md:w-1/3 sm:w-1/2 mb-base" v-for="item in filteredKB" :key="item.id" 
              @click="$router.push(`/admin/${item.refid.toUpperCase() }`).catch(() => {})">
                  <vx-card class="text-center cursor-pointer card-bg">
                      <h2 class="mb-2">{{ item.refid.toUpperCase() }}</h2>
                      <h4 class="mb-2">{{ item.company.toUpperCase() }}</h4>
                      <small class="text-bold">{{ addressFilter(item)}}</small>
                  </vx-card>
              </div>
          </div>
    </div>
</template>

<script>

export default{
  data () {
    return {
      searchQuery: '',
      kb: []
    }
  },
  computed: {
    filteredKB () {
      return this.kb.filter(item => item.company.toLowerCase().includes(this.searchQuery.toLowerCase()) 
      || this.addressFilter(item).toLowerCase().includes(this.searchQuery.toLowerCase())
      || item.refid.toLowerCase().includes(this.searchQuery.toLowerCase())
      )
    }   
  },
  methods: {
    addressFilter (d) {
     return `${d.address1} ${d.address2}, ${d.town}, ${d.postcode}`    
    },
    importMintsoftProducts () {
      this.$vs.loading()
      //const k = []
      // import mintsoft button press
      this.$store.dispatch('dataList/importMintsoftProducts').then(() => {       
        
        this.$vs.loading.close()
        this.$swal({
          icon: 'success',
          title: 'Import',
          text: 'Mintsoft products have been imported',
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Close'
        })
      })
    }
  },
  components: {},
  created () {  
    this.$store.dispatch('dataList/getAllInfopointSites').then(() => {
      this.kb = this.$store.state.dataList.sites  
      this.$vs.loading.close()
    }) 
  }
}
</script>

<style lang="scss">
.knowledge-base-jumbotron-content {
    background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
    background-size: cover;
}
.card-bg{
    background-image: url('../../assets/images/pages/graphic-1.png');
}
.card-bg::before {
    content: "";
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background-color: rgba(255, 255, 255, 0.85);
}
.text-bold{
    font-weight: 900;
}

</style>
